import { useState } from "react"
import axios from "axios"
import Alert from "./Alert"
import { useDispatch, useSelector } from "react-redux"
import { comp } from "../Redux_store/Comp"

const Register = () => {

    const [f_name, setfname] = useState();
    const [l_name, setlname] = useState();
    const [email, setemail] = useState();
    const [password, setpass] = useState();
    const [cpassword, setcpass] = useState();

    const comp1 = useSelector((state) => state.comp.comp)
    const dispatch = useDispatch()

    const [alert, setalert] = useState({
        message: "",
        on: false
    })

    const isrequired = () => {
        if (!f_name || !l_name || !email || !password || !cpassword) {
            setalert({ message: "All fields are required", on: true })
            setTimeout(() => {
                setalert({ message: "", on: false })
            }, 1300);
            return false;
        }
        return true;
    }

    const gotologin = () => {
        dispatch(comp("signin"))
    }
    const reset1 = () => {

        if (isrequired() && (password === cpassword)) {
            // console.log("HI")
            document.getElementById("regform").reset()
        }
    }

    const saveuser = async (e) => {
        e.preventDefault();
        try {
            if (isrequired() && (password === cpassword)) {
                await axios.post(`${process.env.REACT_APP_API_URL}/register`, {
                    f_name,
                    l_name,
                    email,
                    password,
                })
                setalert({ message: "Registration successful!", on: true });
                setTimeout(() => {
                    setalert({ message: "", on: false });
                    dispatch(comp("signin"));
                }, 1300);
            }
        } catch (error) {
            console.log(error.message);
            if (error.response && error.response.status === 400) {
                setalert({ message: error.response.data.message || "Email already in use", on: true });
            } else {
                setalert({ message: "Registration failed", on: true });
            }
            setTimeout(() => {
                setalert({ message: "", on: false });
            }, 1800);
        }
    }

    return (
        <>
            {comp1 === "signup" &&
                <div className="page">

                    <div className="register">
                        <h1 className="text" style={{ textAlign: "center", fontSize: "35px" }}>Sign Up</h1>
                        <hr></hr>

                        <form id="regform" onSubmit={saveuser}>
                            {alert.on && <Alert message={alert.message} />}
                            <div className="form-item Name">
                                <label className="text">First Name</label>
                                <input onChange={(e) => { setfname(e.target.value) }} type="fname" />
                            </div>

                            <div className="form-item Name">
                                <label className="text">Last Name</label>
                                <input onChange={(e) => { setlname(e.target.value) }} type="lname" />
                            </div>

                            <div className="form-item Name">
                                <label className="text">Email address</label>
                                <input onChange={(e) => { setemail(e.target.value) }} type="email" />
                                <div style={{ fontSize: "14px", color: "rgb(171, 75, 75)" }}>We'll never share your email with anyone else.</div>
                            </div>





                            <div className="form-item password">
                                <label className="text">Password</label>
                                <input onChange={(e) => { setpass(e.target.value) }} type="password" />
                            </div>

                            <div className="form-item password">
                                <label className="text">Confirm Password</label>
                                <input onChange={(e) => { setcpass(e.target.value) }} type="password" />
                                {cpassword !== password && <p style={{ fontSize: "13px", color: "rgba(255, 0, 0, 0.57)" }}>password doesn't match</p>}
                            </div>

                            {<button onClick={reset1} className="btn1 text my-4" type="submit">Submit</button>}

                            <div className="go_signup">
                                <h6 style={{ fontSize: "13px", marginTop: "2px" }}>already have an account?</h6>
                                <p style={{ textDecoration: "none", fontSize: "13px", color: "blue", cursor: "pointer" }} onClick={gotologin}>sign in</p>
                            </div>
                        </form>
                    </div>
                </div>
            }
        </>
    )
}

export default Register